import styles from "./Sidebar.module.css"
import React from "react";

const Sidebar = React.forwardRef((props: { children: React.ReactNode, open?: boolean }, ref: React.Ref<HTMLDivElement>) => {
  return <div className={[styles.container, (props.open ? styles.open : "")].join(" ")} ref={ref}>
    {props.children}
  </div>
})

export default Sidebar